import type { IconProps } from '../types/IconProps.ts';
export const ZapOff: IconProps = {
    name: 'ZapOff',
    children: [
        `<path d="m18.48 12 1.8-2.1a.5.5 0 0 0-.37-.83h-4.66a.5.5 0 0 1-.5-.52l.2-6.2a.5.5 0 0 0-.86-.36L11.3 5M8 8.55l-4.23 4.63a.5.5 0 0 0 .37.84h5.1a.5.5 0 0 1 .5.54l-.6 6.9a.5.5 0 0 0 .87.37l5.45-6.33M2 2l20 20" />`,
    ]
};